// integrationUtils.js

import { cleanString } from '../../apiUtils';

export function resolveTypeRows(schemaTypes) {
    const rows = Array.isArray(schemaTypes) ? schemaTypes : [];

    return rows
        .map((row) => ({
            typeId: cleanString(row?.typeId || row?.id || row?.key),
            label: cleanString(row?.label || row?.name || row?.title),
            fields: (Array.isArray(row?.fields) ? row.fields : [])
                .map((field) => ({
                    fieldId: cleanString(field?.fieldId || field?.id || field?.key || field?.name),
                    slug: cleanString(field?.slug || field?.apiName),
                    label: cleanString(field?.label || field?.name || field?.title),
                    type: cleanString(field?.type || field?.dataType || field?.kind),
                }))
                .filter((field) => field.fieldId),
        }))
        .filter((row) => row.typeId)
        .sort((a, b) => a.label.localeCompare(b.label));
}

function toLowerSnake(value) {
    return cleanString(value)
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '_')
        .replace(/^_+|_+$/g, '')
        .replace(/_+/g, '_');
}

export function resolveIncomingFieldAliases(fields, options = {}) {
    const includeNodeId = Boolean(options.includeNodeId);
    const rows = Array.isArray(fields) ? fields : [];
    const baseRows = [
        ...(includeNodeId ? [{
            fieldId: 'id',
            label: 'Node ID',
            type: 'id',
            slug: 'id',
        }] : []),
        {
            fieldId: 'title',
            label: 'Title',
            type: 'text',
            slug: 'title',
        },
        {
            fieldId: 'subtitle',
            label: 'Subtitle',
            type: 'long_text',
            slug: 'subtitle',
        },
        {
            fieldId: 'subtitle',
            label: 'Subtitle',
            type: 'long_text',
            slug: 'description',
        },
    ];
    const used = new Set(baseRows.map((row) => row.slug));

    const customRows = rows.map((field, index) => {
        const fieldId = cleanString(field?.fieldId || field?.id || field?.key || field?.name);
        const label = cleanString(field?.label || field?.name) || '';
        const type = cleanString(field?.type || field?.dataType || field?.kind || 'text').toLowerCase() || 'text';
        const baseSlug = toLowerSnake(field?.slug || label || fieldId) || `field_${index + 1}`;

        let slug = baseSlug;
        let suffix = 2;
        while (used.has(slug)) {
            slug = `${baseSlug}_${suffix}`;
            suffix += 1;
        }
        used.add(slug);

        return {
            fieldId,
            label,
            type,
            slug,
        };
    });

    return [...baseRows, ...customRows];
}

export function normalizeRuleEvent(value) {
    const clean = cleanString(value).toLowerCase();
    if (clean === 'node.deleted') return 'node.deleted';
    if (clean === 'node.updated') return 'node.updated';
    return 'node.created';
}

export function getRuleEventLabel(value) {
    const event = normalizeRuleEvent(value);
    if (event === 'node.deleted') return 'node deleted';
    return event === 'node.updated' ? 'node updated' : 'node created';
}

export function normalizeIncomingAction(value) {
    const clean = cleanString(value).toLowerCase();
    if (clean === 'update') return 'update';
    if (clean === 'create') return 'create';
    return 'create';
}
